import { defineStore } from 'pinia';
import { ref } from 'vue';
import { throwableCall } from '@/api/lib/integration.ts';
import { getBanksApiUserToken } from '@/api/banking/banksApi.ts';
import { captureException } from '@sentry/vue';

export const useBankingStore = defineStore('bankingStore', () => {
  const token = ref('');
  const error = ref<null | string>(null);
  const loading = ref(false);

  async function fetchToken() {
    try {
      loading.value = true;
      error.value = null;

      const { token: userToken } = await throwableCall(getBanksApiUserToken());
      token.value = userToken;
    } catch (err) {
      captureException(err);
      error.value = 'Es gab einen Fehler beim Aufrufen der Banking-Anbindung.';
      throw err;
    } finally {
      loading.value = false;
    }
  }

  function $reset() {
    token.value = '';
    error.value = null;
    loading.value = false;
  }

  return {
    token,
    error,
    loading,
    fetchToken,
    $reset,
  };
});
